function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { DrmType, protectionToDrmType } from '../core/player/playout-data';
import { HdcpLevel } from '@sky-uk-ott/client-lib-js-device';
import { sdkLogger } from '../logger';
import { safeRequestIdleCallback } from '../utils/safe-request-idle-callback';
export var HdcpManager = /*#__PURE__*/ function() {
    "use strict";
    function HdcpManager(deviceCapabilities) {
        _class_call_check(this, HdcpManager);
        _define_property(this, "deviceCapabilities", void 0);
        _define_property(this, "playerCapabilities", void 0);
        _define_property(this, "drmTypes", void 0);
        _define_property(this, "_hdcpSupport", void 0);
        _define_property(this, "logger", void 0);
        _define_property(this, "queueHdcpCheckTimeout", void 0);
        this.deviceCapabilities = deviceCapabilities;
        this.drmTypes = new Set();
        this._hdcpSupport = false;
        this.logger = sdkLogger.withContext('HdcpManager');
        this.queueHdcpCheckTimeout = null;
    }
    _create_class(HdcpManager, [
        {
            key: "isCompliant",
            get: function get() {
                return this._hdcpSupport;
            }
        },
        {
            key: "initialise",
            value: function initialise(capabilities) {
                var _this = this;
                var _this_deviceCapabilities_getPlayoutCapabilities, _this_deviceCapabilities, _this_playerCapabilities_listenToHdcpComplianceChanges, _this_playerCapabilities;
                this.playerCapabilities = capabilities;
                if ((_this_deviceCapabilities_getPlayoutCapabilities = (_this_deviceCapabilities = this.deviceCapabilities).getPlayoutCapabilities) === null || _this_deviceCapabilities_getPlayoutCapabilities === void 0 ? void 0 : _this_deviceCapabilities_getPlayoutCapabilities.call(_this_deviceCapabilities)) {
                    var _this_deviceCapabilities_getPlayoutCapabilities1, _this_deviceCapabilities1;
                    this.drmTypes = (_this_deviceCapabilities_getPlayoutCapabilities1 = (_this_deviceCapabilities1 = this.deviceCapabilities).getPlayoutCapabilities) === null || _this_deviceCapabilities_getPlayoutCapabilities1 === void 0 ? void 0 : _this_deviceCapabilities_getPlayoutCapabilities1.call(_this_deviceCapabilities1).default.reduce(function(accumulated, current) {
                        var drmType = protectionToDrmType(current.protection);
                        if (drmType) {
                            accumulated.add(drmType);
                        }
                        return accumulated;
                    }, new Set());
                }
                this.updateComplianceCache();
                (_this_playerCapabilities_listenToHdcpComplianceChanges = (_this_playerCapabilities = this.playerCapabilities).listenToHdcpComplianceChanges) === null || _this_playerCapabilities_listenToHdcpComplianceChanges === void 0 ? void 0 : _this_playerCapabilities_listenToHdcpComplianceChanges.call(_this_playerCapabilities, function(compliant) {
                    _this._hdcpSupport = compliant;
                    _this.logger.verbose('HDCP compliance changed to', compliant);
                }, Array.from(this.drmTypes));
            }
        },
        {
            key: "onHdcpError",
            value: function onHdcpError() {
                this.logger.verbose('HDCP error detected');
                this._hdcpSupport = false;
            }
        },
        {
            key: "updateComplianceCache",
            value: function updateComplianceCache() {
                var _this = this;
                return this.isHdcpCompliant().then(function(compliant) {
                    _this._hdcpSupport = compliant;
                    _this.logger.verbose('HDCP compliance changed to', compliant);
                    _this.queueHdcpCheck();
                });
            }
        },
        {
            key: "queueHdcpCheck",
            value: function queueHdcpCheck() {
                var _this = this;
                if (this.queueHdcpCheckTimeout) clearTimeout(this.queueHdcpCheckTimeout);
                this.queueHdcpCheckTimeout = setTimeout(function() {
                    var _this1 = _this;
                    safeRequestIdleCallback(/*#__PURE__*/ _async_to_generator(function() {
                        return _ts_generator(this, function(_state) {
                            return [
                                2,
                                _this1.updateComplianceCache().then(function() {
                                    return _this1.queueHdcpCheck();
                                })
                            ];
                        });
                    }));
                }, 120000);
            }
        },
        {
            key: "checkComplianceForDrmTypes",
            value: function checkComplianceForDrmTypes() {
                var drmTypes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [
                    DrmType.Widevine,
                    DrmType.PlayReady
                ];
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        return [
                            2,
                            Promise.all(drmTypes.map(function(drmType) {
                                var _this_playerCapabilities_hdcpCompliance, _this_playerCapabilities;
                                return (_this_playerCapabilities = _this.playerCapabilities) === null || _this_playerCapabilities === void 0 ? void 0 : (_this_playerCapabilities_hdcpCompliance = _this_playerCapabilities.hdcpCompliance) === null || _this_playerCapabilities_hdcpCompliance === void 0 ? void 0 : _this_playerCapabilities_hdcpCompliance.call(_this_playerCapabilities, drmType);
                            })).then(function(results) {
                                return results.some(function(result) {
                                    return result;
                                });
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "isHdcpCompliant",
            value: function isHdcpCompliant() {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_playerCapabilities, _this_playerCapabilities1, _this_playerCapabilities2, _this_playerCapabilities_nonCompliantHdcpLevels, nonCompliantHdcpLevels;
                    return _ts_generator(this, function(_state) {
                        if ((_this_playerCapabilities = _this.playerCapabilities) === null || _this_playerCapabilities === void 0 ? void 0 : _this_playerCapabilities.hdcpCompliance) {
                            return [
                                2,
                                _this.drmTypes ? _this.checkComplianceForDrmTypes(Array.from(_this.drmTypes)) : _this.checkComplianceForDrmTypes()
                            ];
                        } else if (((_this_playerCapabilities1 = _this.playerCapabilities) === null || _this_playerCapabilities1 === void 0 ? void 0 : _this_playerCapabilities1.connectedHdcpLevel) !== undefined) {
                            ;
                            ;
                            nonCompliantHdcpLevels = (_this_playerCapabilities_nonCompliantHdcpLevels = (_this_playerCapabilities2 = _this.playerCapabilities) === null || _this_playerCapabilities2 === void 0 ? void 0 : _this_playerCapabilities2.nonCompliantHdcpLevels) !== null && _this_playerCapabilities_nonCompliantHdcpLevels !== void 0 ? _this_playerCapabilities_nonCompliantHdcpLevels : [
                                HdcpLevel.Disconnected,
                                HdcpLevel.NoSupport,
                                HdcpLevel.Unknown
                            ];
                            return [
                                2,
                                !nonCompliantHdcpLevels.includes(_this.playerCapabilities.connectedHdcpLevel)
                            ];
                        }
                        // If HDCP level cannot be determined
                        // Err on the side of saying it's fine
                        // Worst case, there will be an HDCP error and a VPF retry will recover
                        return [
                            2,
                            true
                        ];
                    });
                })();
            }
        }
    ]);
    return HdcpManager;
}();

//# sourceMappingURL=hdcp-manager.js.map